import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { localeFromPathname, withLocale, SupportedLocale } from '@/i18n/locales';

export function useLocalizedPath(): (path: string) => string {
  const { pathname } = useLocation();
  const locale = localeFromPathname(pathname);
  return (path: string) => withLocale(locale, path);
}

export function useActiveLocale(): SupportedLocale {
  const { pathname } = useLocation();
  return localeFromPathname(pathname);
}

type LocalizedLinkProps = Omit<LinkProps, 'to'> & { to: string };

const LocalizedLink: React.FC<LocalizedLinkProps> = ({ to, ...rest }) => {
  const localizedPath = useLocalizedPath();
  return <Link to={localizedPath(to)} {...rest} />;
};

export default LocalizedLink;
